import Seo from "@/components/feature/Seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import EvidenceTypes from "./components/EvidenceTypes";
import FeaturedEvents from "./components/FeaturedEvents";
import CategoryGrid from "./components/CategoryGrid";
import LatestUpdates from "./components/LatestUpdates";
import GuideSteps from "./components/GuideSteps";
import FaqPreview from "./components/FaqPreview";
import SubmitCta from "./components/SubmitCta";

const rawBase = import.meta.env.BASE_URL || "/";
const base = rawBase === "/" ? "" : rawBase.replace(/\/$/, "");

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "131吃瓜",
      alternateName: "131吃瓜实锤证据合集",
      url: `${base}/`,
      description:
        "131吃瓜把实锤证据与证据合集集中放在一起，包括截图、录音等可见素材，按事件类型分类整理，方便对照前后说法。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${base}/events?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "131吃瓜",
      url: `${base}/`,
      description: "专注整理公开可见素材的吃瓜证据合集站点。",
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "线索提交与纠错",
        email: "hello@131chigua.com",
        availableLanguage: ["zh-CN"],
      },
    },
  ];

  return (
    <>
      <Seo
        title="131吃瓜 · 实锤证据合集｜截图录音整理更新"
        description="131吃瓜实锤与证据合集持续整理更新中，把截图证据、录音证据、文字记录与时间线按事件类型集中归档，方便对照前后说法，不听单方讲故事，直接翻证据汇总栏。"
        keywords="131吃瓜,实锤,证据合集,石锤,截图证据,录音证据"
        path="/"
        type="website"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main>
        <Hero />
        <EvidenceTypes />
        <FeaturedEvents />
        <CategoryGrid />
        <LatestUpdates />
        <GuideSteps />
        <FaqPreview />
        <SubmitCta />
      </main>
      <SiteFooter />
    </>
  );
}